<template>
  <div class="main-layout yx-major-adjust-page">
    <CCollapseItem>
      <template slot="title-left"> 专业调整配置 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom" shadow="never">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <div class="div-scroll">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          v-loading="pageLoading"
          @edit="goto"
          @delete="pageDel"
        >
          <template slot="custom" slot-scope="scope">
            <span>{{ getRuleType(scope.row.type) }}</span>
          </template>
        </c-table>
        <div class="rule-container">
          <div class="title">规则：</div>
          <div class="content">
            <p v-for="(item, index) in pageData" :key="item.id">
              {{ index + 1 }}、 学生类别<span class="blue">{{
                item.studentTypeName || "-"
              }}</span
              >, 专业类别<span class="blue">{{ item.majorName || "-" }}</span
              >, 省份<span class="blue">{{ item.provinceName || "-" }}</span
              >, 规则<span class="blue">{{
                getRuleType(item.type) || "-"
              }}</span
              >；
            </p>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 编辑弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            @submit="submit"
            @resetFields="resetFields"
          >
            <c-form-item :formItems="formItems" />
            <el-form-item label="录取专业" prop="majorIdList">
              <select-tree
                :label="major"
                :value="handleData.majorIdList"
                :options="treeData"
                :props="tree.props"
                :showCheckbox="true"
                @getMajor="handleGetMajor"
              />
            </el-form-item>
            <!-- 可调专业，针对必须跳转专业设置 -->
            <el-form-item
              label="可调专业"
              prop="toMajorIdList "
              v-if="handleData.type == 2 || handleData.type == 3"
            >
              <select-tree
                :label="toMajor"
                :value="handleData.toMajorIdList"
                :options="treeData"
                :props="tree.props"
                :showCheckbox="true"
                @getMajor="handleGetAdjustMajor"
              />
            </el-form-item>
          </c-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "../data/majorAdjust";
import SelectTree from "./checkboxTree";
import {
  getOrgOptions,
  getRoleOptions,
  getLinkOptions,
} from "@/libs/searchSelect.js";
let mPage = MPage({
  pagePath: "/welcome-live/exchange/rule/listPage",
  pageDelPath: "/welcome-live/exchange/rule",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "/welcome-live/exchange/rule",
  handleInsertPath: "/welcome-live/exchange/rule/save",
  handleUpdatePath: "/welcome-live/exchange/rule/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  components: {
    SelectTree,
  },
  data() {
    let { searchItems, tableColumns, formItems, formRules, tree } =
      Configs(this);
    return {
      SUCCESS_CODE: "",
      isFold: false,
      searchItems,
      tableColumns,
      formItems,
      formRules,
      tree,
      idList: [],
      title: "",
      dialogFormVisible: false,
      defaultHandleData: {
        name: "",
        type: "",
        studentTypeList: [],
        provinceCodeList: [],
        majorIdList: [],
        toMajorIdList: [], // 可调专业列表
      },
      major: { name: "" },
      toMajor: { name: "" },
      treeData: [],
    };
  },
  created() {
    this.handleData = Object.assign({}, this.defaultHandleData);
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.getTreeData();
  },
  mounted() {},
  methods: {
    goto(data) {
      console.log(this.handleData);
      this.major = { name: "" };
      this.toMajor = { name: "" };
      let id = data.id;
      this.handleData = Object.assign({}, this.defaultHandleData);
      if (id) {
        this.handleGet(id);
        this.title = "编辑";
      } else {
        this.title = "新增";
      }
      this.dialogFormVisible = true;
    },
    handleGetAfterFn(data) {
      this.major.name = data.majorName;
      this.toMajor.name = data.toMajorName;
    },
    getRuleType(type) {
      if (type == 1) {
        return "不允许调整专业";
      } else if (type == 2) {
        return "允许在本专业类别范围内调整专业";
      } else {
        return "必须在专业范围内调整专业";
      }
    },
    // 获取树节点数据
    getTreeData() {
      this.$http.get("/account/sys/org/getOrgTree").then((res) => {
        console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          this.treeData = res.data[0].children;
        }
      });
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    handleGetMajor(data) {
      // console.log(data)
      this.handleData.majorIdList = data;
    },
    handleGetAdjustMajor(data) {
      this.handleData.toMajorIdList = data;
    },
    submit() {
      console.log(this.handleData);
      // 判断是不是允许在专业范围内调整类型
      // if(this.handleData.type == 2 && this.handleData.majorIdList.length == 0) {
      //   console.log(111)
      //   return this.$message.error('请选择录取专业！')
      // }
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    // 提交之前数据处理
    handleBeforeFn() {},
    handleAfterFn() {
      this.$refs.cForm.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
      this.pageGet(true);
    },
    resetFields() {
      this.dialogFormVisible = false;
      this.$refs.cForm.$refs.cForm.resetFields();
    },
    handleDialogClose() {
      this.$refs.cForm.$refs.cForm.resetFields();
    },
  },
};
</script>
